module.exports = __webpack_public_path__ + "img/conciliation-prix-2-petit.cb4abeeb.jpeg";